class RangeFacet extends HTMLElement {
    constructor() {
        super();
        this.progress = this.querySelector('.progress');
        this.maxInputRange = this.querySelector('.range-input-max');
        this.minInputRange = this.querySelector('.range-input-min');
        this.maxInputText = this.querySelector('.range-max-text');
        this.minInputText = this.querySelector('.range-min-text');
        this.priceGap = 5;
        this.init();
        this.addEventListener('input', this.onChangeHandler.bind(this));
    }
    init() {
        this.setValueProgress(this.maxInputRange);
        this.setValueProgress(this.minInputRange);
    }
    onChangeHandler(e) {
        const target = e.target;
        console.log(target);
        if(target.type == 'range') {
            this.setValueProgress(target);   
        }
    }

    setValueProgress(input) {

        const minVal = input.type == 'number' ? Number(this.minInputText.value) : Number(this.minInputRange.value);
        const maxVal = input.type == 'number' ? Number(this.maxInputText.value) : Number(this.maxInputRange.value);
        if (maxVal - minVal < this.priceGap) {
            if (input.classList.contains('range-min')) {
                this.minInputRange.value  = maxVal - this.priceGap;
                this.minInputText.value  = maxVal - this.priceGap;
            } else {
                this.maxInputRange.value = minVal + this.priceGap;
                this.maxInputText.value = minVal + this.priceGap;
            }
        } else {
            this.minInputRange.value = minVal;
            this.maxInputRange.value = maxVal;
            this.minInputText.value = minVal;
            this.maxInputText.value = maxVal;
            this.progress.style.left = (minVal / Number(input.max)) * 100 + "%";
            this.progress.style.right = 100 - (maxVal /  Number(input.max)) * 100 + "%";
        }
        
    }
}

customElements.define('custom-range-price', RangeFacet);